import { BaseDto } from '../../core';
import { Product, ProductOption } from '.';
import { Utils } from '../../common';

export class MapperSaleProduct extends BaseDto<MapperSaleProduct> {
  constructor(partial?: any) {
    super(partial);
    this.init();
  }

  id: number;
  productId: number;
  sort: number;
  isDisplay: boolean;
  created: Date;
  updated: Date | null;
  product?: Product;
  productOption?: ProductOption;

  hasStockError: boolean;
  hasQuantityMaxError: boolean;
  hasQuantityMinError: boolean;
  hasInboxError: boolean;
  totalQuanityError: boolean;
  /** 오류 여부 */
  hasError: boolean;

  /** 선택된 수량 */
  quantity: number;
  /** 수량에 계산된 상품 가격 */
  totalSalePriceUSD: number;

  /** 바뀐 수량(inbox 기존값 저장?) */
  changeInboxQuantity: number;
  /** 옵션 여부 */
  optionCheck: boolean;
  /** 일괄 선택 선택 여부 */
  addBulkChecked: boolean;
  /** true: InBox, false: OutBox 여부 */
  isInbox: boolean = false;

  init() {
    /**
     * 최소 구매 수량이 있다면 최소구매수량을 세팅한다.
     * 오류를 초기화 한다.
     */
    this.quantity = this.productOption && this.productOption.minMoq ? this.productOption.minMoq : 0;
    this.initErrors();
  }

  initErrors() {
    this.hasStockError = false;
    this.hasQuantityMaxError = false;
    this.hasQuantityMinError = false;
    this.hasInboxError = false;
    this.totalQuanityError = false;
    this.hasError = false;
  }

  isInvalidCountry(countryCode: string) {
    return this.productOption.invalidCountry.includes(countryCode);
  }

  changeQuantity(quantity: number, error?: string) {
    this.quantity = quantity;
    this.totalSalePriceUSD = this.quantity * this.productOption.salePriceUSD;
    if (error) {
      this[error] = true;
      this.hasError = true;
    }
  }

  addUnitQuantity(isPlus: boolean) {
    const productOption = this.productOption;
    const addition = productOption.isSaledInbox ? this.checkUquickStockMoq(isPlus).inboxQuantity : 1;
    this.checkQuantity(this.quantity + (isPlus ? addition : -1 * addition));
  }

  checkUquickStockMoq(isPlus?: boolean) {
    if (!this.productOption.isFixedMoq) {
      if (
        this.productOption.rocketStock !== null &&
        this.productOption.rocketStock >= Number(this.quantity + (isPlus ? 1 : -1))
      ) {
        if (this.productOption.rocketStock < 5) {
          this.productOption.minMoq = 1;
          this.productOption.inboxQuantity = 1;
        } else {
          if (
            isPlus &&
            this.productOption.rocketStock - this.quantity >= 5 &&
            this.productOption.rocketStock > this.quantity
          ) {
            if (this.changeInboxQuantity !== 1) {
              this.productOption.minMoq = 5;
              this.productOption.inboxQuantity = 5;
            }
          }
          if (
            isPlus &&
            this.productOption.rocketStock - this.quantity < 5 &&
            this.productOption.rocketStock > this.quantity
          ) {
            this.productOption.minMoq = 1;
            this.productOption.inboxQuantity = 1;
          }

          if (
            !isPlus &&
            this.quantity % 5 === 0 &&
            this.productOption.rocketStock > Number(this.quantity + (isPlus ? 1 : -1))
          ) {
            if (this.changeInboxQuantity !== 1) {
              this.productOption.minMoq = 5;
              this.productOption.inboxQuantity = 5;
            }
          }
          if (
            !isPlus &&
            this.quantity % 5 !== 0 &&
            this.productOption.rocketStock > Number(this.quantity + (isPlus ? 1 : -1))
          ) {
            this.productOption.minMoq = 1;
            this.productOption.inboxQuantity = 1;
            if (this.productOption.rocketStock !== this.quantity) {
              if (this.quantity < 5 && this.changeInboxQuantity !== 1) {
                this.quantity = 5;
              } else {
                this.quantity = Math.floor((this.quantity / 5) * 5);
              }
            }
          }
          if (
            !isPlus &&
            this.quantity % 5 === 0 &&
            this.productOption.rocketStock === Number(this.quantity + (isPlus ? 1 : -1))
          ) {
            this.productOption.minMoq = 5;
            this.productOption.inboxQuantity = 5;
            this.quantity = Math.floor(Number(this.quantity + (isPlus ? 1 : -1)) / 5) * 5;
          }
        }
      } else {
        if (
          !isPlus &&
          this.quantity + (isPlus ? 1 : -1) - this.productOption.minMoq <= this.productOption.rocketStock
        ) {
          if (Math.floor(this.productOption.rocketStock / 5) * 5 > 0) {
            this.productOption.minMoq = Math.floor(this.productOption.rocketStock / 5) * 5;
            this.productOption.inboxQuantity = Math.floor(this.productOption.rocketStock / 5) * 5;

            this.quantity = Math.floor(this.productOption.rocketStock / 5) * 5;
          } else {
            if (this.productOption.rocketStock > 0) {
              this.productOption.minMoq = 1;
              this.productOption.inboxQuantity = 1;
              this.quantity = 1;
            }
          }
        } else {
          if (
            this.productOption.rocketStock < this.quantity &&
            this.productOption.isSaledInbox &&
            !Number.isInteger(this.quantity / this.productOption.inboxQuantity)
          ) {
            if (this.quantity !== this.productOption.rocketStock + this.productOption.inboxQuantity) {
              this.quantity =
                Math.floor(this.quantity / this.productOption.inboxQuantity) * this.productOption.inboxQuantity;
            }
          } else {
            this.productOption.minMoq = this.changeInboxQuantity;
            this.productOption.inboxQuantity = this.changeInboxQuantity;
          }
        }
      }
    }
    return this.productOption;
  }

  initUquickStockMoq(inboxQuantity?: number) {
    const productOption = this.productOption;
    this.changeInboxQuantity = inboxQuantity;

    if (!this.productOption.isFixedMoq && this.productOption.rocketStock > 0) {
      if (this.productOption.rocketStock < 5) {
        this.productOption.minMoq = 1;
        this.productOption.inboxQuantity = 1;
      } else {
        if (productOption.minMoq === 1) {
          this.productOption.minMoq = 1;
          this.productOption.inboxQuantity = 1;
        } else {
          this.productOption.minMoq = 5;
          this.productOption.inboxQuantity = 5;
        }
      }
    }
  }

  checkQuantity(quantity?: number) {
    quantity = quantity || Utils.toNumber(this.quantity);
    const productOption = this.productOption;

    this.initErrors();

    const calcQuantity = (q: number, inboxQuantity: number, isOver: boolean) => {
      return (Math.floor(q / inboxQuantity) + (isOver ? 1 : 0)) * inboxQuantity;
    };

    if (!productOption.isSaledInbox) {
      if (productOption.stock !== null && quantity > productOption.stock) {
        this.changeQuantity(productOption.stock, 'hasStockError');
        // selectedMapperSaleProduct.quantity = quantity;
      } else if (productOption.stock !== null && productOption.stock < productOption.minMoq) {
        this.changeQuantity(productOption.minMoq, 'hasStockError');
      } else if (productOption.deletedStock !== null && quantity > productOption.deletedStock) {
        this.changeQuantity(productOption.deletedStock, 'hasStockError');
        // selectedMapperSaleProduct.quantity = quantity;
      } else if (productOption.deletedStock !== null && productOption.deletedStock < productOption.minMoq) {
        this.changeQuantity(productOption.minMoq, 'hasStockError');
      } else {
        if (quantity > productOption.maxMoq) {
          this.changeQuantity(productOption.maxMoq, 'hasQuantityMaxError');
          // selectedMapperSaleProduct.quantity = quantity;
        } else {
          if (quantity >= productOption.minMoq) {
            // selectedMapperSaleProduct.quantity = quantity;
            this.changeQuantity(quantity);
          } else {
            this.changeQuantity(productOption.minMoq, 'hasQuantityMinError');
            // selectedMapperSaleProduct.quantity = quantity;
          }
        }
      }
    } else {
      if (productOption.stock !== null && quantity > productOption.stock) {
        const q = calcQuantity(productOption.stock, productOption.inboxQuantity, false);
        this.changeQuantity(q === 0 ? productOption.minMoq : q, 'hasStockError');
        // selectedMapperSaleProduct.quantity = quantity;
      } else if (productOption.stock !== null && productOption.stock < productOption.minMoq) {
        const q = calcQuantity(productOption.stock, productOption.inboxQuantity, false);
        this.changeQuantity(q === 0 ? productOption.minMoq : q, 'hasStockError');
      } else if (productOption.deletedStock !== null && quantity > productOption.deletedStock) {
        const q = calcQuantity(productOption.deletedStock, productOption.inboxQuantity, false);
        this.changeQuantity(q === 0 ? productOption.minMoq : q, 'hasStockError');
        // selectedMapperSaleProduct.quantity = quantity;
      } else if (productOption.deletedStock !== null && productOption.deletedStock < productOption.minMoq) {
        const q = calcQuantity(productOption.deletedStock, productOption.inboxQuantity, false);
        this.changeQuantity(q === 0 ? productOption.minMoq : q, 'hasStockError');
      } else {
        if (quantity > productOption.maxMoq) {
          const q = calcQuantity(productOption.maxMoq, productOption.inboxQuantity, false);
          this.changeQuantity(q, 'hasQuantityMaxError');
          // selectedMapperSaleProduct.quantity = quantity;
        } else {
          if (quantity > productOption.minMoq) {
            if (quantity % productOption.inboxQuantity === 0) {
              // selectedMapperSaleProduct.quantity = quantity;
              this.changeQuantity(quantity);
            } else {
              if (productOption.stock !== null && quantity >= productOption.stock) {
                const q = calcQuantity(productOption.stock, productOption.inboxQuantity, false);
                // selectedMapperSaleProduct.quantity = quantity;
                this.changeQuantity(q === 0 ? productOption.minMoq : q, 'hasStockError');
              } else if (productOption.deletedStock !== null && quantity >= productOption.deletedStock) {
                const q = calcQuantity(productOption.deletedStock, productOption.inboxQuantity, false);
                // selectedMapperSaleProduct.quantity = quantity;
                this.changeQuantity(q === 0 ? productOption.minMoq : q, 'hasStockError');
              } else {
                if (productOption.rocketStock) {
                  const q = quantity;
                  this.changeQuantity(q, null);
                } else {
                  const q = Math.round(quantity / productOption.inboxQuantity) * productOption.inboxQuantity;
                  this.changeQuantity(q, null);
                }
                // const q = Math.round(quantity / productOption.inboxQuantity) * productOption.inboxQuantity;
                // selectedMapperSaleProduct.quantity = quantity;
                // this.changeQuantity(q, 'hasInboxError');
                // this.changeQuantity(q, null);
              }
            }
          } else if (quantity === productOption.minMoq) {
            // TODO 낼 체크 해봐야 함
            if (productOption.minMoq <= productOption.inboxQuantity) {
              // selectedMapperSaleProduct.quantity = quantity;
              this.changeQuantity(productOption.inboxQuantity, null);
            } else {
              // product.hasInboxError = false;
              const q = calcQuantity(productOption.minMoq, productOption.inboxQuantity, false);
              // selectedMapperSaleProduct.quantity = quantity;
              this.changeQuantity(q, 'hasQuantityMinError');
            }
          } else {
            if (productOption.minMoq <= productOption.inboxQuantity) {
              // product.quantity = productOption.inboxQuantity;
              this.changeQuantity(productOption.inboxQuantity, 'hasQuantityMinError');
              // selectedMapperSaleProduct.quantity = quantity;
            } else {
              const q = calcQuantity(productOption.minMoq, productOption.inboxQuantity, false);
              this.changeQuantity(q, 'hasQuantityMinError');
              // selectedMapperSaleProduct.quantity = quantity;
            }
          }
        }
      }
    }
  }
}
